const KeenSlider = window.KeenSlider

class MediaCollageCarousel extends window.BAO.CarouselElement {
  connectedCallback () {
    super.connectedCallback()

    if (this.dataset?.autoplayEnable === 'true') {
      this.settings = {
        autoplay: true,
        autoplayFrequencey: this.dataset?.autoplayDuration,
      }
    }

    this.carousel = this.initialiseCarousel()
  }

  initialiseCarousel () {
    if (!this.els?.slides?.exists || !this.els?.slide?.exists) return
    return new KeenSlider(this.els.slides.element, {
      selector: this.els.slide.selector,
      drag: true,
      loop: true,
      mode: 'snap',
      rubberband: true,
      slides: {
        origin: 'center',
        perView: 1.1,
        spacing: 3,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: {
            origin: 'auto',
            perView: 2.5,
            spacing: 15,
          },
        },
        '(min-width: 1201px)': {
          slides: {
            origin: 'auto',
            perView: 3.5,
            spacing: 15,
          },
        },
      },
    })
  }
}

if (!customElements.get('media-collage-carousel')) {
  customElements.define('media-collage-carousel', MediaCollageCarousel)
}
